import { produce } from "immer";
import { useCallback, useEffect, useState } from "react";

import useProductLineSaver from "./useProductLineSaver";

function replacer(key, value) {
    if (key === "__typename") return undefined;
    if (value === null) return undefined;
    return value;
}

export default function useProductLineEditor(productLine, isDirtyRef?) {
    const [raw, setRaw] = useState(undefined);

    const reset = useCallback(
        () => {
            setRaw(
                JSON.parse(
                    JSON.stringify(productLine ?? {}),
                    replacer,
                )
            );
        },
        [productLine],
    );

    useEffect(
        reset,
        [productLine],
    );

    const reader = { ...(raw ?? {}) };

    function markDirty() {
        if (isDirtyRef) isDirtyRef.current = true;
    }

    const writer = {
        key(key) {
            markDirty();
            setRaw(produce((draft) => { draft.key = key; }));
        },
        image(image) {
            markDirty();
            setRaw(produce((draft) => { draft.image = image; }));
        },
        name(name) {
            markDirty();
            setRaw(produce((draft) => { draft.name = name; }));
        },
        parameterIDs(parameterIDs) {
            markDirty();
            setRaw(produce((draft) => { draft.parameterIDs = parameterIDs; }));
        },
    };

    const { save, error } = useProductLineSaver(productLine, raw, isDirtyRef);

    return {
        reader,
        reset,
        writer,
        raw,
        save,
        error,
    };
}
